// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type SearchHit = {
  entity: string;
  refId: string;
  title: string;
  subtitle?: string | null | undefined;
  url: string;
};
export const SearchHitSchema = z.object({
  entity: z.string(),
  refId: z.string(),
  title: z.string(),
  subtitle: z.string().nullable().optional(),
  url: z.string(),
}).strict();

export type SearchResults = {
  query: string;
  hits: Array<SearchHit>;
};
export const SearchResultsSchema = z.object({
  query: z.string(),
  hits: z.array(SearchHitSchema),
}).strict();

export type SearchResponse = SearchResults;

export const SearchQuerySchema = z.object({
  q: z.string().min(1).max(120),
});

export async function search(query?: {
  q: string;
}): Promise<SearchResponse> {
  const response = await api.get<SearchResponse>(`/search`, { params: query });
  return response.data;
}

export const searchKeys = {
  all: ["search"] as const,
  lists: () => [...searchKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...searchKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...searchKeys.all, 'detail'] as const,
  detail: (id: string) => [...searchKeys.details(), id] as const,
};
